import SidebarModule from './sidebar.module'

export default SidebarModule
